import { type JSX } from "react";
import Script from "next/script";
import { useConsent } from "lib/consent/useConsent";

export const SalesforceInteractionsScripts = (): JSX.Element | null => {
  const evergageAccount = process.env.NEXT_PUBLIC_EVERGAGE_ACCOUNT || "";
  const evergageDataset = process.env.NEXT_PUBLIC_EVERGAGE_DATASET || "";
  const scriptUrl = `https://cdn.evgnet.com/beacon/${evergageAccount}/${evergageDataset}/scripts/evergage.min.js`;
  const consentGranted = useConsent("functional");
  if (!consentGranted) return null;
  return (
    <>
      {evergageAccount && evergageDataset && (
        <Script
          id="salesforce-interactions-script"
          src={scriptUrl}
          strategy="afterInteractive"
          defer={true}
          className="optanon-category-C0003"
          onError={() => {
            console.error("Failed to load SalesforceInteractions script");
          }}
        />
      )}
    </>
  );
};

// Alternative export for backwards compatibility
export const EvergageScripts = SalesforceInteractionsScripts;
